module.exports = __webpack_public_path__ + "img/McD_Standorte_Content_images_01.cd6e82c5.jpg";